import * as swcHelpers from '@swc/helpers';
import { slugify, QueryString } from '@grandvisionhq/utils';

const createBreadcrumbs = (store, rootLabel, storesRoute)=>{
    if (!storesRoute) {
        console.error('createBreadcrumbs: Could not create breadcrumbs because storesRoute was not found');
        return [];
    }
    return [
        {
            name: 'Home',
            url: '/'
        },
        {
            name: rootLabel,
            url: storesRoute
        },
        {
            name: store.breadcrumbName && store.breadcrumbSlug ? store.breadcrumbName : store.town,
            url: store.breadcrumbName && store.breadcrumbSlug ? store.breadcrumbSlug : `${storesRoute}?search=${store.town}`
        },
        {
            name: `${store.name}`,
            url: `${storesRoute}/${store.slug}`
        }, 
    ];
};
const getBookAppointmentUrl = (bookAppointmentUrl, options)=>{
    return (store)=>{
        var ref, ref1;
        const { code  } = store;
        let result = bookAppointmentUrl;
        if ((options === null || options === void 0 ? void 0 : (ref = options.alternativeUrl) === null || ref === void 0 ? void 0 : ref.length) && (options === null || options === void 0 ? void 0 : (ref1 = options.alternativeUrlStores) === null || ref1 === void 0 ? void 0 : ref1.includes(code))) {
            result = options.alternativeUrl;
        }
        if (options === null || options === void 0 ? void 0 : options.paddedLength) {
            const storeId = String(code).padStart(options.paddedLength, '0');
            result = `${result}?storeId=${storeId}`;
        } else {
            result = `${result}?storeId=${code}`;
        }
        return result;
    };
};
var _slug;
const getStoreDetailUrl = (storesListUrl)=>(store)=>`${storesListUrl}/${slugify(store.town)}/${(_slug = store.slug) !== null && _slug !== void 0 ? _slug : store.code}`
;
const areServicesAvailable = (store, services)=>{
    var ref;
    return !(store === null || store === void 0 ? void 0 : (ref = store.servicesNotAvailable) === null || ref === void 0 ? void 0 : ref.some((notAvailable)=>services.includes(notAvailable)
    ));
};
const isEqualStores = (a, b)=>{
    if (a === b) {
        return true;
    }
    if (a.length !== b.length) {
        return false;
    }
    const codes = a.map(({ code  })=>code
    );
    for (const store of b){
        const index = codes.indexOf(store.code);
        if (index === -1) {
            return false;
        }
        codes.splice(index, 1);
    }
    return true;
};
const removeEmptyValues = (queryParams)=>Object.entries(queryParams).filter(([, value])=>value !== null && value !== undefined && value !== ''
    ).reduce((acc, [key, value])=>swcHelpers.objectSpread({}, acc, {
            [key]: value
        })
    , {})
;
var getStoreFinderUrlWithNewQueryParams = (newQueryParams)=>{
    const queryParams = QueryString.parse(window.location.search.substring(1));
    /** Remove old search and userLocation parameters before setting newQueryParams */ const restQueryParams = swcHelpers.objectWithoutProperties(queryParams, [
        "userLocation",
        "search"
    ]);
    /** Remove empty parameters to avoid having ?something=true&search= in url */ const params = swcHelpers.objectSpread({}, removeEmptyValues(restQueryParams), removeEmptyValues(newQueryParams));
    const isEmptyParams = Object.keys(params).length === 0;
    return `${window.location.pathname}${QueryString.stringify(params, isEmptyParams)}`;
};
const replaceStoreFinderUrlWithNewQueryParams = (newQueryParams)=>{
    window.history.replaceState(null, 'store-finder', getStoreFinderUrlWithNewQueryParams(newQueryParams));
};

export { areServicesAvailable, createBreadcrumbs, getBookAppointmentUrl, getStoreDetailUrl, getStoreFinderUrlWithNewQueryParams, isEqualStores, removeEmptyValues, replaceStoreFinderUrlWithNewQueryParams };
//# sourceMappingURL=store-utils.js.map
